import { ApiReportReportTypeChoices, ReportSectionsType } from "@api/graphql/types-and-hooks";
import {
  useIsReportBaseTemplate,
  useIsReportCompleted,
  useIsReportHandlebars,
  useIsReviewPage,
} from "@components/ReportField/capabilities/flags";
import { APPENDIX_PAGE_LOCATION } from "@components/ReportField/consts";
import { useReport } from "@providers/ReportProvider";

// Whether "Move Up"/"Move Down" show, off review and not completed. Reproduces
// the legacy per-surface gating:
//   assessment  (InitialAssessment)          -> handlebars export
//   evaluation  (DiagnosisEvaluation + step) -> base template or appendix
//   clinical    (Reassessment | DE + single) -> handlebars, or single-page appendix
export const useCanReorderSection = (section: ReportSectionsType): boolean => {
  const { report, viewMode } = useReport();
  const isHandlebars = useIsReportHandlebars();
  const isBaseTemplate = useIsReportBaseTemplate();
  const isReviewPage = useIsReviewPage();
  const isCompleted = useIsReportCompleted();

  if (isReviewPage || isCompleted) return false;

  if (report.reportType === ApiReportReportTypeChoices.DiagnosisEvaluation && viewMode === "step") {
    return isBaseTemplate || section.pageLocation === APPENDIX_PAGE_LOCATION;
  }

  // clinical (Reassessment | Diagnosis Evaluation single-page)
  if (isHandlebars) return true;
  const isDiagnosisSinglePage =
    report.reportType === ApiReportReportTypeChoices.DiagnosisEvaluation && viewMode === "single";
  return isDiagnosisSinglePage && section.pageLocation === APPENDIX_PAGE_LOCATION;
};
